import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class SharedTools {
  isEmpty(text:any) {
    return ((typeof text in ['undefined', 'null']) || text == '' || text == []) ? true : false;
  }

  emailValidator(control:any) {
    if (control.value) {
      const matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

  format343TelephoneNumber(text:any) {
    let output = '';

    if (text && !this.isEmpty(text)) {
      let input = text.replaceAll(/[-()\ ]/g, '');
      let iLen = input.length;

      if (!isNaN(parseInt(input))) {
        if (iLen >= 3 && iLen < 7) {
          output = `${input.substr(0, 3)}-${input.substr(3)}`;
        } else if (iLen >= 7) {
          output = `${input.substr(0, 3)}-${input.substr(3, 4)}-${input.substr(7, 3)}`;
        } else {
          output = input;
        }
      }
    }

    return output;
  }

  formatPhTelephoneNumber(text:any) {
    let output = '';

    if (text && !this.isEmpty(text)) {
      let input = text.replaceAll(/[-()\ ]/g, '');
      let iLen = input.length;

      if (!isNaN(parseInt(input))) {
        if (iLen >= 4 && iLen < 7) {
          output = `${input.substr(0, 4)}-${input.substr(4)}`;
        } else if (iLen >= 7) {
          output = `${input.substr(0, 4)}-${input.substr(4, 3)}-${input.substr(7, 4)}`;
        } else {
          output = input;
        }
      }
    }

    return output;
  }

  formatUsTelephoneNumber(text:any) {
    let output = '';

    if (text && !this.isEmpty(text)) {
      let input = text.replaceAll(/[-()\ ]/g, '');

      let iLen = input.length;

      if (!isNaN(parseInt(input))) {
        if (iLen >= 3 && iLen < 6) {
          output = `${input.substr(0, 3)}-${input.substr(3)}`;
        } else if (iLen >= 6) {
          output = `${input.substr(0, 3)}-${input.substr(3, 3)}-${input.substr(6, 4)}`;
        } else {
          output = input;
        }
      }
    }

    return output;
  }

  formatPhPhoneTelephoneNumber(text:any) {
    let output = '';

    if (text && !this.isEmpty(text)) {
      let input = text.replaceAll(/[-()\ ]/g, '');
      let iLen = input.length;

      if (!isNaN(parseInt(input))) {
        if (iLen >= 4 && iLen < 7) {
          output = `${input.substr(0, 3)}-${input.substr(3, 3)}`;
        } else if (iLen >= 7) {
          output = `${input.substr(0, 3)}-${input.substr(3, 3)}-${input.substr(6, 4)}`;
        } else {
          output = input;
        }
      }

      /* alert(output)
      //.substr(1, input.length);
      if(output.length == 11)
      {

      } */
    }

    return output;
  }

  allowNumberOnly(e:any){
    const regexpNumber = /[0-9\+\-\ ]/;
    let inputCharacter = String.fromCharCode(e.charCode);
    if (e.keyCode!=null && e.keyCode != 8  && e.keyCode!=46 && e.key!='.' && !regexpNumber.test(inputCharacter)) {
      e.preventDefault();
    }
  }

  validateAmount(amount: any)
  {
    var exceed = false
    if(amount > 5000.00)
    {
      exceed = true;
    }

    return exceed
  }

}
